









































































































import userApi from "@/api/userApi";
import qNotify from "@/common/qNotify";
import Company from "@/model/company";
import { LINK_TYPE } from "@/model/user";
import defineAbilityFor from "@/services/ability";
import store from "@/store";
import {DATE_FORMAT, DATE_FORMAT_JA} from '@/common/constant';
import _ from "lodash";
import { Component, Vue } from "vue-property-decorator";
// import AuthModule from "@/store/modules/auth";
import { namespace } from "vuex-class";
import UserCompany from "@/model/userCompany";
import moment from "moment/moment";

const auth = namespace("Auth");
@Component({
  name: "SelectCompanyLogin",
})
export default class SelectCompanyLogin extends Vue {

  @auth.Getter
  getCompanyLinked!: Company[]
  @auth.Getter
  getUserCompanies!:UserCompany[]

  get userName(): Company[] {
    return this.$store.state.Auth.userLogging.username;
  }

  get userCompanies(): UserCompany[] {
    return this.getUserCompanies.map((item) => new UserCompany(item));
  }

  public isDirectUser(type) {
    return LINK_TYPE.DIRECT === type;
  }

  public goToDashboard(userCompany) {
    // go to dashboard or CM110
    // set header
    store.dispatch("Auth/setUsingCompany", userCompany.id);
    this.$ability.update(defineAbilityFor(this.$store.state.Auth.userLogging.type, userCompany.role_id).rules);
    if (
      userCompany.company && userCompany.company.representative_user_id === this.$store.state.Auth.userLogging.id
    ) {
      // TODO if is representative_user_id = login id
      this.$router.push({ name: "admin.company" });
    } else {
      this.$router.push({
        name: "admin.dashboard",
      });
    }
  }

  public selectLinkWaiting(userCompany) {
    this.$modal.showDelete({
      title: "連携確認",
      is_question: false,
      text: `${userCompany.companyName} ${userCompany.requesterName}さんから連携申請が届きました。</br>承認すると、${userCompany.companyName ? userCompany.companyName + 'へ' : ''}ログイン可能になります。`,
      confirmText: "承認する",
      confirmClass: "mb__add-color-green",
      cancelText: "却下する",
      cancelClass: "mb__add-color-red",
      type: "info",
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        const result = await userApi.link({
          user_company_id: userCompany.id,
          type: 1,
        });
        if (result.meta.status === 200) {
          store.dispatch("Auth/setUsingCompany", userCompany.id);
          this.$ability.update(defineAbilityFor(this.$store.state.Auth.userLogging.type, userCompany.role_id).rules);
          const companies = _.cloneDeep(this.getCompanyLinked).map(item => {
            if (userCompany.company && item.id === userCompany.company.id) {
              item.pivot.status = 1;
            }
            return item;
          });
          const userCompanies = _.cloneDeep(this.getUserCompanies).map(item => {
            if (item.id === userCompany.id) {
              item.status = 1;
            }
            return item;
          });
          store.dispatch("Auth/setCompanyLinked", companies);
          store.dispatch("Auth/setUserCompanies", userCompanies);
          this.$router.push({
            name: "admin.dashboard",
          });
        } else {
          qNotify.error({
            text: result.meta.message,
          });
        }
      },
      onClose: async () => {
        const result = await userApi.link({
          user_company_id: userCompany.id,
          type: 0,
        });
        if (result.meta.status === 200) {
          const companies = this.getCompanyLinked.filter(
            (item) => userCompany.company && item.id !== userCompany.company.id
          );
          const userCompanies = this.getUserCompanies.filter(
            (item) => item.id !== userCompany.id
          );
          store.dispatch("Auth/setCompanyLinked", companies);
          store.dispatch("Auth/setUserCompanies", userCompanies);
        } else {
          qNotify.error({
            text: result.meta.message,
          });
        }
      },
    });
  }

  public getNow() {
    return moment().format(DATE_FORMAT);
  }

  public formatDate(date) {
    return moment(date).format(DATE_FORMAT_JA)
  }
  public isOffCompanyByLicense(company) {
    if (!(company.license_is_active) && company.license_is_oldest) {
      return moment(this.getNow()).isBefore(moment(company.license_is_oldest.applicable_date).format(DATE_FORMAT));
    }

    return false;
  }
}
